export class attachmentModel {
    base64: any;
    filename: string;
    filesize: number;
    filetype: string;
    isProfile:boolean;
    isSchool: boolean;
    profileId:string;
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/layouts/admin/attachment.model.ts